module.exports = __webpack_public_path__ + "static/img/page top img_no sew_desktop.3f675497.jpg";